import React, { useCallback, useContext } from "react";
import { Button, Progress } from "antd";
import { ErrorCode, Status } from "../../type";
import { btns } from "../../config/btn.config";
import { StatusDescComs } from "../Desc";
import Icon from "@/utils/antdIcon";
import "./index.less";
import { RetryIcon, ErrorIcon, SuccessIcon } from "../Icons";
import { isFocusEnv } from "@/utils";
import { formatFileName } from "@/components/UploadBox/utils";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";
import { changeEgovUrl } from "@/utils/tools";
import { ChatMessageType } from "@/types/chat";
import egovFileIcon from "@/assets/images/im/egov-file-icon.png";

interface IProps {
  id: any;
  title: string;
  currentProgress: number;
  currentSize: string;
  size: string;
  imgUrl: string;
  status: Status | ErrorCode;
  type?: string;
  callback: (status: Status) => void;
}
export const Item = (props: IProps) => {
  const {
    id,
    title = "",
    currentSize = "",
    currentProgress = 0,
    size = "",
    imgUrl = "",
    status,
    type,
    callback
  } = props;
  const { onLine } = useContext(GlobalContext);
  const createBtn = useCallback(() => {
    let btn = btns.error;
    let IconCmps = () => <span />;
    if (
      ((status === Status.PROGRESS || status === Status.WAITING) && !onLine) ||
      status === Status.CANCEL
    ) {
      btn = btns[Status.RETRY];
      IconCmps = () => <Icon component={RetryIcon} />;
    } else if (status === Status.PROGRESS || status === Status.WAITING) {
      btn = btns[Status.CANCEL];
      IconCmps = () => (
        <>
          <span className="item-progress-num">{currentProgress}%</span>
          <Progress
            type="circle"
            strokeWidth={10}
            width={20}
            showInfo={false}
            percent={currentProgress}
          />
        </>
      );
    } else if (status === Status.SUCCESS) {
      btn = btns[Status.SUCCESS];
      IconCmps = () => <Icon component={SuccessIcon} />;
    } else {
      btn = btns[Status.ERROR];
      IconCmps = () => <Icon component={ErrorIcon} />;
    }
    if (!isFocusEnv() && status === Status.SUCCESS) {
      return <span />;
    }
    return (
      <>
        <span className="item-status">
          <IconCmps />
        </span>
        <Button
          type="link"
          block
          className="item-btn"
          onClick={() => {
            callback(btn.handleEvent);
          }}
        >
          {btn.text}
        </Button>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, currentProgress, callback, onLine]);
  return (
    <div className="download-item">
      {/* 文件icon */}
      <div className="item-left">
        <img className="file-icon" src={imgUrl} />
        {/* <img src={changeEgovUrl(fileIcon)} alt="" className="file-icon" draggable="false" /> */}
        {type === ChatMessageType.EGOV_FILE && (
          <img src={changeEgovUrl(egovFileIcon)} className="egov-file-icon" alt="" />
        )}
      </div>

      {/* 下载进度及文件title */}
      <div className="item-center">
        <h3>{formatFileName(title)}</h3>
        <p>
          <StatusDescComs status={status} size={size} progress={currentSize} />
        </p>
      </div>
      {/* 展示按钮 */}
      <div className="item-right">{createBtn()}</div>
    </div>
  );
};
